import type { Access, Identity, RoleType } from './types';

/** ADMIN role at GLOBAL scope: sees every tenant. */
export function isGlobalAdmin(identity: Identity | null | undefined): boolean {
  return identity?.roleContext.roleType === 'ADMIN' && identity.roleContext.scope === 'GLOBAL';
}

/** Is the user's role one of `roles`? (portal-ui-lib's `roleGuard` check.) */
export function hasRole(
  identity: Identity | null | undefined,
  roles: readonly RoleType[],
): boolean {
  return identity ? roles.includes(identity.roleContext.roleType) : false;
}

/** Does the user hold `permission` (e.g. `lead:update`), overrides included? */
export function hasPermission(access: Access | null | undefined, permission: string): boolean {
  return access?.permissions.includes(permission) ?? false;
}

/** Is `feature` switched on at the node the access was resolved for? */
export function isEntitled(access: Access | null | undefined, feature: string): boolean {
  return access?.entitlements.includes(feature) ?? false;
}
